import styled, { keyframes, css } from 'styled-components';

const loading = keyframes`
  to {
    background-position: 0%;
  }
`;

const Container = styled.div`
  background-color: #fff;
  height: 90vh;
  border-radius: 10px;
  box-shadow: 0 0 50px #3334;
  padding: 0px;
  position: relative;
  padding-right: 20px;
  padding-top: 20px;
  overflow: hidden;
`;

const Info = styled.div`
  width: 100%;
`;

const Title = styled.p`
  font-size: 1.1rem;
  color: #666;
  font-weight: 600;
  margin-bottom: 25px;
`;

const Label = styled.p`
  color: #429488;
  font-weight: 600;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 20px;
`;

const Content = styled.p`
  color: #707070;
`;

const ContentList = styled.ul`
  list-style: none;
  margin: 0;
`;

const ContentItem = styled.li`
  color: #707070;
  padding: 14px 0;
  border-bottom: 1px solid #ccc;
`;

const ItemIndex = styled.span`
  font-weight: 600;
  color: #707070;
  display: inline-block;
  margin-right: 10px;
`;

const ImgCard = styled.img`
  width: 50px;
  margin-right: 15px;
  object-fit: contain;
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  font-size: 15px;
  color: #ffffff;
  border: none;
  background-color: ${props => props.color || '#009688'};
  padding: 14px 0;
  font-weight: 600;
  border-radius: 8px;
  width: 100%;
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;

  span {
    background: linear-gradient(to right, #fff 50%, #009688 50%);
    background-size: 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: ${props =>
      props.loading ? 'transparent' : '#009688'};
    animation: ${loading} 2s ease-in-out forwards;
  }

  ${props =>
    props.loading
      ? css`
          background-color: #424242;
          background-image: linear-gradient(to right, #009688 50%, #424242 50%);
          background-repeat: no-repeat;
          background-size: 200%;
          background-position: 100%;

          animation: ${loading} 2s ease-in-out forwards;
        `
      : null}

  &:active {
    transform: translateY(10px);
  }

  .loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px;
    display: grid;
    place-content: center;
    background-color: white;
  }

  &:disabled {
    background-color: #f4f4f4;
    color: #707070;
    cursor: not-allowed;
    transform: none;
  }
`;

const ActionsBar = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
`;

const ScrollContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  overflow: scroll;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 60px;
  height: 100%;

  &::-webkit-scrollbar {
    width: 12px; /* width of the entire scrollbar */
  }

  &::-webkit-scrollbar-track {
    background: #fff; /* color of the tracking area */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #429488; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 3px solid #fff; /* creates padding around scroll thumb */
  }
`;

export {
  Container,
  Title,
  Label,
  Content,
  Info,
  ContentList,
  ContentItem,
  ItemIndex,
  ImgCard,
  Button,
  ActionsBar,
  ScrollContainer,
};
